import React, { FC, MouseEvent } from "react";
import { AddCircleOutline } from "@mui/icons-material";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";
import { Avatar, Box, Button, Typography } from "@mui/material";

import InputField from "../../../../common/Form/Input/InputField";
import FormDropdownField from "../../../../common/Form/Dropdown/FormDropdownField";

import fileUploadService from "../../../../../services/fileUpload";

import styles from "../CreateECMember.module.scss";
import IMAGES from "../../../../../constants/images";
import { logger } from "../../../../../utils/logger";
import { EC_MEMBER_TYPE, ROLES } from "../../../../../constants";
import FormToggleButton from "../../../../common/Form/ToggleButton/FormToggleButton";
import { getTimeStamp } from "../../../../../utils/helper";
import {
  AVATAR,
  IS_AFFILIATED_TO_MEDANTA,
  MEMBER_TYPE,
  NAME,
  QUALIFICATION,
  ROLES_IN_EC,
} from "../../../../../constants/forms";
import DropdownWithOther from "../../../IRB/IRBSubmission/CreateIRBSubmission/StudyDetails/DropdownWithOther";
const MemberDetails: FC = (): JSX.Element => {
  const { values, setFieldValue, validateForm, setErrors } =
    useFormikContext<FormikValues>();

  const dropdownInputHandler = (fieldName: string, value: any) => {
    setFieldValue(fieldName, value);
  };

  const checkFormValidation = (modifiedValues: FormikValues) => {
    validateForm(modifiedValues).then((res) => {
      setErrors(res);
    });
  };

  const rowInputHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
    i: number
  ) => {
    const name = e.target.name;
    const value = e.target.value;

    const prevData = [...values[name]];

    prevData[i] = value;

    setFieldValue(name, prevData);

    checkFormValidation({ ...values, [QUALIFICATION]: prevData });
  };

  const addInputFromGrid = () => {
    const prevData = [...values[QUALIFICATION]];
    setFieldValue(QUALIFICATION, [...prevData, ""]);
  };

  const deleteInputGrid = (i: number) => {
    const filteredData = [...values[QUALIFICATION]].filter(
      (item, index) => index !== i
    );
    if (filteredData.length > 0) {
      setFieldValue(QUALIFICATION, filteredData);
    }
    checkFormValidation({ ...values, [QUALIFICATION]: filteredData });
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!e.target.files) return;

    try {
      const imageUrl = await fileUploadService.upload(
        e.target.files,
        `${getTimeStamp()}-${AVATAR}`
      );
      // setSelectedFile(e.target.files[0]);
      setFieldValue(AVATAR, imageUrl.data);
    } catch (err) {
      logger.error({ err });
    }
  };

  return (
    <>
      <InputField
        label={"1.1 EC member full name"}
        name={NAME}
        placeholder={"Write EC member full name"}
      />

      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">
          1.2 Upload the member photo
        </label>
        <Box className={`${styles.uploadProfile} d-flex`}>
          <Avatar
            className={`${styles.avatar60} mg-r-16`}
            alt="profile"
            src={values[AVATAR] || IMAGES.Profile}
          />
          <Box className="upload-box d-flex align-items-center justify-content-center">
            <label htmlFor="file-upload">
              <i className="icon-upload-cloud mg-r-10"></i>
              <Typography
                className="mg-r-6 font-size-sm font-weight-medium"
                variant={"subtitle1"}
                component={"span"}
              >
                Click to upload
              </Typography>
              <Typography
                className="font-size-sm"
                variant={"subtitle1"}
                component={"span"}
                color={"secondary"}
              >
                or drag and drop png, jpg or gif
              </Typography>
            </label>
            <div className="hidden-input">
              <input
                id="file-upload"
                // value={selectedFile}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleFileUpload(e)
                }
                type="file"
                accept="image/*"
                className="form-control"
                name={AVATAR}
              />
            </div>
          </Box>
        </Box>
      </Box>

      <FormDropdownField
        label="1.3  Type of Committee"
        value={values[MEMBER_TYPE]}
        name={MEMBER_TYPE}
        options={[ROLES.MIRB, ROLES.MIEC, ROLES.MSMC]}
        inputHandler={dropdownInputHandler}
      />

      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14 font-weight-medium">
          1.4 Qualification of the member
        </label>
        {values[QUALIFICATION].map((_item: any, i: number) => (
          <Box className="d-flex mg-b-10" key={i}>
            <input
              value={_item}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                rowInputHandler(e, i)
              }
              className="form-control"
              name={QUALIFICATION}
              placeholder="Qualification of the EC member"
            />
            <Button onClick={() => deleteInputGrid(i)} type="button">
              <img src={IMAGES.Delete} alt="" />
            </Button>
          </Box>
        ))}
        <Box>
          <ErrorMessage
            name={QUALIFICATION}
            render={(msg) => <span className=" font-size-sm">{msg}</span>}
          />
        </Box>
        <Button
          variant={"text"}
          color={"error"}
          onClick={addInputFromGrid}
          type="button"
        >
          <AddCircleOutline className="mg-r-10" />
          Add Other if any
        </Button>
      </Box>

      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14 font-weight-medium">
          1.5 Is Member Affiliation to Medanta?{" "}
        </label>
        <FormToggleButton name={IS_AFFILIATED_TO_MEDANTA} />
      </Box>

      <DropdownWithOther
        label="1.6  Role in Ethics committee/MIRB"
        name={ROLES_IN_EC}
        placeholder={"Role in Ethics committee/MIRB"}
        options={EC_MEMBER_TYPE}
        disabled={false}
      />
    </>
  );
};

export default MemberDetails;
